import Link from 'next/link';
import Image from 'next/image';
import { FooterCertifications } from './_components/footer-certifications';
import { FaleConoscoModal } from './_components/fale-conosco-modal';
import { caixaStd } from '@/app/tag-com-beneficios-caixa/fonts';

const linkColumns = [
  {
    title: 'PARA VOCÊ',
    links: [
      {
        label: 'tagCAIXA',
        href: 'https://minhacontatag.caixaprepagos.com.br/',
      },
      {
        label: 'CAIXA Alimentação',
        href: 'https://voce.caixaprepagos.com.br/',
      },
      { label: 'CAIXA Refeição', href: 'https://voce.caixaprepagos.com.br/' },
      { label: 'CAIXA Multi', href: 'https://voce.caixaprepagos.com.br/' },
      { label: 'Parcerias', href: 'https://parcerias.caixaprepagos.com.br/' },
    ],
  },
  {
    title: 'PARA SUA EMPRESA',
    links: [
      { label: 'CAIXA Alimentação', href: '/alimentacao' },
      { label: 'CAIXA Refeição', href: '/refeicao' },
      { label: 'CAIXA Multi', href: '/multi' },
      { label: 'tagCAIXA Empresas', href: '/tagcaixa' },
      { label: 'frotaCAIXA', href: '/frotacaixa' },
      { label: 'vtCAIXA', href: '/vtcaixa' },
      { label: 'despesaCAIXA', href: '/despesacaixa' },
    ],
  },
  // {
  //   title: 'PARCEIROS',
  //   links: [
  //     { label: 'Explorar Parceiros', href: '#' },
  //     { label: 'Seja um Parceiro', href: '#' },
  //     { label: 'Portal do Parceiro', href: '#' },
  //     { label: 'Níveis de Parceria', href: '#' },
  //   ],
  // },
  {
    title: 'INSTITUCIONAL',
    links: [
      { label: 'Fale Conosco' },
      {
        label: 'Relacionamento com Investidor',
        href: '/relacionamento-com-investidores',
      },
      { label: 'Código de Ética', href: '/codigo-de-etica' },
      {
        label: 'Canal de Ética',
        href: 'https://canal.ouvidordigital.com.br/caixaprepagos',
      },
      {
        label: 'Relatório de Transparência Salarial',
        href: '/transparencia-salarial',
      },
      {
        label: 'Perguntas Frequentes',
        href: 'https://cloud.comunicacao.caixaprepagos.com.br/CACRFAQ',
      },
      { label: 'Blog', href: '/blog' },
    ],
  },
];

const socialLinks = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/caixaprepagos',
    icone: { src: '/tagcaixa-cartao/facebook.png', largura: 7, altura: 14 },
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/caixaprepagos',
    icone: { src: '/tagcaixa-cartao/instagram.png', largura: 14, altura: 14 },
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/caixaprepagos',
    icone: { src: '/tagcaixa-cartao/linkedin.png', largura: 14, altura: 14 },
  },
];

const bottomLinks = [
  { label: 'Termos de Privacidade', href: '/aviso-de-privacidade' },
];

const centralAtendimento = {
  titulo: 'CENTRAL DE ATENDIMENTO',
  blocos: [
    { rotulo: 'Capitais e Regiões Metropolitanas:', destaque: '3003 9590' },
    { rotulo: 'Demais Localidades:', destaque: '0800 721 9590' },
  ],
  horario: {
    rotulo: 'Horário de atendimento:',
    linhas: ['9h às 18h de segunda à sexta-feira', '9h às 15h aos sábados'],
  },
};

export function Footer() {
  return (
    <footer
      className={`${caixaStd.variable} bg-[#0066B3] font-[family-name:var(--font-caixa-std)] text-[#cfe0f0] pt-[52px] pb-[150px] min-[760px]:pb-[30px]`}
    >
      <div className="max-w-7xl mx-auto px-6 xl:px-0 flex gap-7 flex-wrap justify-between min-[760px]:gap-10">
        <div className="flex-1 min-w-[260px] max-w-[330px] mx-auto text-center min-[760px]:mx-0 min-[760px]:text-left">
          <Image
            src="/tagcaixa-cartao/logo-caixa-prepagos-rodape.png"
            alt="CAIXA Pré-Pagos"
            width={200}
            height={27}
            className="mb-4 h-auto w-[220px] mx-auto min-[760px]:w-[200px] min-[760px]:mx-0"
            priority={false}
          />
          <p className="text-[14px] leading-relaxed opacity-85 min-[760px]:text-[13px]">
            Simplificar a experiência de pagamento de todos os brasileiros.
            Soluções de mobilidade e benefícios com tecnologia e segurança
            CAIXA.
          </p>
          <div className="flex gap-2.5 mt-5 justify-center min-[760px]:justify-start">
            {socialLinks.map(({ label, href, icone }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-9 h-9 min-[760px]:w-[34px] min-[760px]:h-[34px] rounded-[10px] bg-[#0F4C8C] flex items-center justify-center"
              >
                <Image
                  src={icone.src}
                  alt=""
                  width={icone.largura}
                  height={icone.altura}
                />
              </a>
            ))}
          </div>
          <div className="mt-6">
            <FooterCertifications />
          </div>
        </div>

        <div className="hidden min-[760px]:grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-9 flex-[2] min-w-[300px]">
          {linkColumns.map((column) => (
            <div key={column.title}>
              <h3 className="text-[#F5871F] font-extrabold text-[13px] tracking-wide mb-4">
                {column.title}
              </h3>
              <ul className="flex flex-col gap-[11px] text-[13.5px] opacity-90">
                {column.links.map((link) => (
                  <li key={link.label}>
                    {link.href ? (
                      <Link href={link.href}>{link.label}</Link>
                    ) : (
                      <FaleConoscoModal />
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="w-full text-center text-white min-[760px]:hidden">
          <h3 className="text-[#F5871F] text-[20px] font-bold">
            {centralAtendimento.titulo}
          </h3>
          {centralAtendimento.blocos.map(({ rotulo, destaque }) => (
            <div key={rotulo} className="mt-6">
              <p className="text-[16px] opacity-85">{rotulo}</p>
              <p className="mt-1.5 text-[28px] font-bold">{destaque}</p>
            </div>
          ))}
          <div className="mt-6">
            <p className="text-[16px] opacity-85">
              {centralAtendimento.horario.rotulo}
            </p>
            {centralAtendimento.horario.linhas.map((linha, i) => (
              <p
                key={linha}
                className={
                  i === 0
                    ? 'mt-1.5 text-[28px] font-bold'
                    : 'text-[28px] font-bold'
                }
              >
                {linha}
              </p>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-[34px] px-6 xl:px-0 pt-6 border-t border-white/15 flex flex-col items-center justify-center text-center gap-3.5 text-[12px] opacity-85 min-[760px]:flex-row min-[760px]:items-start min-[760px]:justify-between min-[760px]:gap-10 min-[760px]:text-left">
        <p className="min-[760px]:flex-1">
          2026 | CAIXA Pré-Pagos | CNPJ 39.459.331/0001-20 | Todos os direitos
          reservados. A CAIXA Cartões Pré-Pagos S.A. é uma empresa privada. Os
          conteúdos e informações divulgados referem-se exclusivamente às
          atividades da Companhia.
        </p>
        <div className="flex shrink-0 gap-6 whitespace-nowrap">
          {bottomLinks.map((link) => (
            <Link key={link.label} href={link.href}>
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
